import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { BaseUrl } from "../../helper/BaseUrl";
import { DateConvert } from "../../helper/DateConvert";
import { fetchJson } from "../../helper/fetchJson";

// const blogs = [
//   {
//     img: "/assets/images/blog-listing-image2.webp",
//     title: "Building Sustainable Supply Chains with Green TMS Approaches",
//     date: "12 Sep 2025",
//     author: "admin",
//   },
//   {
//     img: "/assets/images/blog-listing-image3.webp",
//     title: "Enhancing Customer Experience Through Smarter Deliveries",
//     date: "19 Sep 2025",
//     author: "admin",
//   },
//   {
//     img: "/assets/images/blog-listing-image4.webp",
//     title: "Delivering Better Customer Experiences with Smarter TMS Tools",
//     date: "28 Aug 2025",
//     author: "admin",
//   },
//   {
//     img: "/assets/images/blog-listing-image5.webp",
//     title: "How Automation is Redefining Transportation Management",
//     date: "24 Aug 2025",
//     author: "admin",
//   },
//   {
//     img: "/assets/images/blog-listing-image3.webp",
//     title: "Enhancing Customer Experience Through Smarter Deliveries",
//     date: "19 Sep 2025",
//     author: "admin",
//   },
//   {
//     img: "/assets/images/blog-listing-image4.webp",
//     title: "Delivering Better Customer Experiences with Smarter TMS Tools",
//     date: "28 Aug 2025",
//     author: "admin",
//   },


// ];

export default function BlogPost({ initialData }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [allData, setAllData] = useState(initialData || []);
  const [visibleCount, setVisibleCount] = useState(6);
  const [isLoadMore, setIsLoadMore] = useState(true);

  // search filter
   const filteredBlogs = allData.filter((blog) =>
    blog.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // API Calling
  const fetcher = async () => {
    try {
      const result = await fetchJson(`${BaseUrl}/api/aiblogs`);

      if (result.blogs === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.blogs);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    if (!initialData?.length) {
      fetcher();
    }
  }, [initialData])

 
 const handleLoadMore = () => {
    if (isLoadMore) {
      setVisibleCount((prev) => {
        const newCount = Math.min(prev + 3, filteredBlogs.length);
        if (newCount >= filteredBlogs.length) {
          setIsLoadMore(false);
        }
        return newCount;
      });
    } else {
      setVisibleCount(6);
      setIsLoadMore(true);
    }
  };
  if (!allData) {
    return <div style={{ height: "100vh", width: "100%" }}></div>;
  }

  return (
    <>
      <section className="blog-listing">
        <img src="/assets/images/blog-listing-curve.webp" alt="curve" className="img-responsive curve-image" />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="warehouse-text heading-gap heading-center ">
                <span className="subtitle">SMARTER TMS INSIGHTS</span>
                <h1 className="heading">Inside The Future of Logistics</h1>
                <p>Inside The Future of Logistics, technology and sustainability are transforming the industry. Mobility Infotech Supply Chain AI, automation, and smart systems are driving faster, more efficient operations.</p>
                <form onSubmit={(event) => event.preventDefault()}>
                  <fieldset className="fieldInput">
                    <input type="email" required="" className="form-input form-control" name="email" placeholder="Search TMS blogs & articles…" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    <button type="submit" className="form-submit"><i className="fa-solid fa-magnifying-glass"></i></button>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <div className="row">
           {filteredBlogs.slice(0, visibleCount).map((data, index) => (
              <div key={index} className="col-sm-6 col-md-6 col-lg-4 blog-card">
                <div className="blog-card-inner">
                  <img src={`${BaseUrl}${data?.image}`} className="img-responsive" alt={data?.name} loading="lazy" />
                  <div className="blog-info">
                    <div className="blog-meta">
                      <img src={`${BaseUrl}${data?.author_image}`} className="img-responsive" alt={data?.author_name} loading="lazy" /> Written by<span>{data?.author_name}</span>
                    </div>
                    <div className="heading">{data?.name?.slice(0,80) + "..."}</div>
                    <div className="info-bottom">
                      <div className="date">
                        <div className="blog-date">{DateConvert(data?.date)}</div>
                      </div>
                      <div className="link-text">
                        <Link className="hover-link" to={`/blogs/${data?.slug}`}> <i className="fa-solid fa-arrow-right"></i>
                          <span className="sr-only">Read more about {data?.name}</span>
                         </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
            {filteredBlogs.length > visibleCount && (
            <div className="row">
              <div className="col-md-12">
                <div className="load-more">
                  <Link onClick={handleLoadMore} className="theme-btn">
                    <span>{isLoadMore ? "View More" : "View Less"}</span>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  )
}
